var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 5,
    viewBox: "0 0 10 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99953 4.66652C4.84376 4.66683 4.69281 4.61258 4.57287 4.51319L0.572866 1.17986C0.436722 1.0667 0.351105 0.904092 0.334852 0.727807C0.318599 0.551523 0.37304 0.376002 0.486199 0.239858C0.599358 0.103714 0.761966 0.0180976 0.93825 0.00184445C1.11453 -0.0144087 1.29005 0.0400322 1.4262 0.153191L4.99953 3.13986L8.57287 0.259858C8.64106 0.204481 8.71952 0.163127 8.80375 0.138172C8.88797 0.113218 8.9763 0.105155 9.06365 0.114448C9.15101 0.123741 9.23566 0.150205 9.31275 0.192321C9.38984 0.234437 9.45785 0.291374 9.51287 0.359858C9.57392 0.428406 9.62016 0.508823 9.64869 0.596072C9.67722 0.683322 9.68742 0.775522 9.67866 0.866898C9.66989 0.958273 9.64236 1.04685 9.59777 1.12709C9.55318 1.20733 9.4925 1.2775 9.41953 1.33319L5.41953 4.55319C5.29614 4.63687 5.14827 4.67677 4.99953 4.66652Z",
    fill: "#ADADAD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowFilter);
export default __webpack_public_path__ + "static/media/arrowFilter.1dc4a9dd.svg";
export { ForwardRef as ReactComponent };